// Shared so SideMenuTemplate, Router and the view itself can't drift on rename.
// SideMenuTemplate cannot import from the view directly (PageTemplate ->
// PrimaryNavigation -> SideMenuTemplate creates a cycle), so these constants
// live in their own module that all three can pull in.
import copy from './copy.json'

export const FACIAL_RECOGNITION_PATH = '/facial-recognition'

export const FACE_OFF_FLAG_KEY = 'faceOffEnabled'

export interface FacialRecognitionTab {
  id: string
  label: string
  // Each tab has its own ConfigCat flag, because the tools have different
  // audiences. The page and its menu item show when any tab flag is on.
  flagKey: string
  path: string
}

// Registry order is tab order. New tools arrive as new entries here, plus a
// component in tabs/index.ts.
export const FACIAL_RECOGNITION_TABS: FacialRecognitionTab[] = [
  {
    id: 'faceOff',
    label: copy.tabs.faceOff,
    flagKey: FACE_OFF_FLAG_KEY,
    path: `${FACIAL_RECOGNITION_PATH}/face-off`,
  },
]
